export const brandStyles = {
  bgColor: "brand.50",
  color: "brand.800",
};

export const greenStyles = {
  bgColor: "cdsGreen.50",
  color: "tagGreen.text",
};

export const errorStyles = {
  bgColor: "statusRed.bg",
  color: "statusRed.text",
};

export const grayStyles = {
  bgColor: "bg.tertiary",
  color: "content.tertiary",
};

export const blueStyles = {
  bgColor: "dateBlue.background",
  color: "dateBlue.500",
};

export const orangeStyles = {
  bgColor: "cdsOrange.50",
  color: "cdsOrange.500",
};

export const orangeYellowStyles = {
  bgColor: "cdsOrange.100",
  color: "cdsOrange.900",
};

const ACTION_STATUS_STYLE_MAP = {
  pending: brandStyles,
  delivered: greenStyles,
  error: errorStyles,
  skipped: grayStyles,
  removed: grayStyles,
  immediate: blueStyles,
};

export function toActionStatusStyles(status: keyof typeof ACTION_STATUS_STYLE_MAP): typeof ACTION_STATUS_STYLE_MAP[keyof typeof ACTION_STATUS_STYLE_MAP] {
  if (!(status in ACTION_STATUS_STYLE_MAP)) {
    throw new Error(`Invalid status: ${status}. Expected one of: ${Object.keys(ACTION_STATUS_STYLE_MAP).join(", ")}`);
  }
  return ACTION_STATUS_STYLE_MAP[status];
}

const ISSUE_STATUS_STYLE_MAP = {
  resolved: greenStyles,
  unresolved: grayStyles,
};

export function toIssueStatusStyles(status: keyof typeof ISSUE_STATUS_STYLE_MAP): typeof ISSUE_STATUS_STYLE_MAP[keyof typeof ISSUE_STATUS_STYLE_MAP] {
  if (!(status in ISSUE_STATUS_STYLE_MAP)) {
    throw new Error(`Invalid status: ${status}. Expected one of: ${Object.keys(ISSUE_STATUS_STYLE_MAP).join(", ")}`);
  }
  return ISSUE_STATUS_STYLE_MAP[status];
}
